module.exports = __webpack_public_path__ + "static/media/target.26d686a7.png";